export default {
  login: {
    title: 'ログイン',
    button: {
      login: 'ログイン',
      reset_password: 'パスワードを再設定',

    },
    label: {
      login_id: 'ログインID',
      password: 'パスワード',
      email: 'メールアドレス',
      forgot_your_password: 'パスワードを忘れた方は',
      kochira: 'こちら',
    },
    messages: {
      fail: 'ログインID、パスワードをご確認ください。',
    },
  },
  reset_password: {
    title: 'パスワードをお忘れですか？',
    label: {
      enter_you_email: 'メールアドレスを入力してください',
      password: 'パスワード',
      password_confirmation: 'password_confirmation',
    },
    button: {
      send: '送信',
      back_to_login: 'ログイン画面に戻る',
    },
    form: {},
  },
  confirm_password: {
    title: 'パスワードの再設定',
    label: {
      enter_new_pass: '新しいパスワードを入力',
      password_confirm: 'パスワード確認用',
    },
    button: {
      reset: 'パスワードの再設定',
    },
  },
  show_message_check_email: {
    title: 'メールをご確認ください',
    content1: 'パスワード再設定メールを入力したメールアドレス宛にお送りしました。',
    content2: 'お送りしたメールの内容に従ってパスワードを再設定してください。',
    button: 'ログイン画面に戻る',
  },
  show_message_reset_success: {
    title: 'パスワードを再設定しました',
    content: '次回から新しいパスワードでログインできます。',
    button: 'ログイン画面に戻る',
  },
};
